import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  APP_IN_FOREGROUND: null,
  APP_IN_BACKGROUND: null,
  // PUBNUB
  INITIALIZE_VISITOR_ONLINE_CHANNEL: null,
  SET_CURRENT_CHANNEL: null,
  CLEAR_CURRENT_CHANNEL: null,
  ADD_MESSAGE_TO_CONVERSATION: null
});